<mat-card-header>
	<mat-card-title>
		Group School Enrollments
	</mat-card-title>
</mat-card-header>
<mat-divider> </mat-divider>


<mat-tab-group class="margin-top-sm" [(selectedIndex)]="selectedTabIndex">
	<mat-tab label="Group Enrollment Search">
		<mat-card appearance="outlined" class="card-content-wrapper">
			<div class="row gx-0">
				<div class="col-lg-6">
					<mat-card-header>
						<mat-card-title>
							Search Criteria
						</mat-card-title>
					</mat-card-header>
					<mat-card-content>
						<region-dropdown-two-way [isMultiple]="false" [required]="true" [reset]="resetField"
							[(selectedRegions)]="chosenRegions" (loadingChange)="regionLoading.set($event)">
						</region-dropdown-two-way>

						<county-dropdown-two-way [isMultiple]="false" [(selectedCounties)]="chosenCounties"
							[reset]="resetField" [required]="true" [regions]="chosenRegions"
							(loadingChange)="countyLoading.set($event)">
						</county-dropdown-two-way>

						<district-dropdown-two-way [isMultiple]="false"
							[(selectedSchoolDistricts)]="chosenSchoolDistricts" [reset]="resetField" [required]="true"
							[regions]="chosenRegions" [counties]="chosenCounties"
							(loadingChange)="districtLoading.set($event)">
						</district-dropdown-two-way>

						<school-dropdown-two-way [isMultiple]="true" [(selectedSchools)]="chosenSchools"
							[reset]="resetField" [regions]="chosenRegions" [counties]="chosenCounties"
							[schoolDistricts]="chosenSchoolDistricts" (loadingChange)="schoolLoading.set($event)">
						</school-dropdown-two-way>

						<app-school-year [yearType]="'SchoolYear'"
							(performancePeriodEvent)="performancePeriodEvent($event)" [reset]="resetField"
							[selectSchoolYear]="selectSchoolYear" [required]="true">
						</app-school-year>
					</mat-card-content>
					<mat-card-header>
						<mat-card-title>
							Enrollment Type *
							<help-text-btn class="align-help-text-btn" [helpTextId]="'EnrollmentType'"></help-text-btn>
						</mat-card-title>
					</mat-card-header>
					<mat-card-content>
						<div class="row">
							<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="rAttending">
								Regular School Year - Attending</mat-checkbox>
							<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="rNotAttending">
								Regular School Year - Not Attending</mat-checkbox>
						</div>
					</mat-card-content>

				</div>
				<div class="col-lg-6">
					<mat-card-header>
						<mat-card-title>
							Filters
							<help-text-btn class="align-help-text-btn"
								[helpTextId]="'GroupSchoolEnrollments_Filters'"></help-text-btn>
						</mat-card-title>
					</mat-card-header>

					<mat-card-content>
						<div class="row">
							<mat-checkbox [color]="'primary'" class="checkbox-margin-sm"
								[(ngModel)]="expiredEligibility">
								Include children without Eligibility in Period (EiP)</mat-checkbox>
							<mat-checkbox [color]="'primary'" class="checkbox-margin-sm" [(ngModel)]="expiredQAD">
								Include children with expired QAD</mat-checkbox>
							<mat-checkbox [color]="'primary'" class="checkbox-margin-sm"
								[(ngModel)]="notWithdrawnFromSchool">
								Only include children without a withdrawal date</mat-checkbox>
						</div>

						<div class="row">
							<grade-dropdown class="col-lg-12" [(chosenGrades)]="chosenGrades"
								(gradeEvent)="gradeEventEmitter($event)" [isMultiple]="false" [reset]="resetField">
							</grade-dropdown>
						</div>
					</mat-card-content>
				</div>
			</div>
			<mat-card-actions>
				<button mat-raised-button color="primary" mat-button [disabled]="!this.checkValid() || isLoading"
					(click)="search()" class="margin-right-sm">
					<mat-icon *ngIf="isLoading">
						<mat-spinner diameter="18"> </mat-spinner>
					</mat-icon>
					Search
				</button>
				<button mat-raised-button color="accent" (click)="reset()" mat-button>Reset</button>
			</mat-card-actions>
		</mat-card>

		<app-msg [msg]="msg" *ngIf="!msg.SUCCESS"></app-msg>


		@if (isBackupLoading()) {
		<div class="spinner-overlay">
			<div class="loading-container">
				<mat-spinner diameter="40"></mat-spinner>
				<div class="loading-text">
					Loading<span class="dots"></span>
				</div>
			</div>
		</div>
		}

		<div [hidden]="results.length === 0" class="margin-top-md">
			<h2>
				Search Results - {{tableDataSources[0]?.filteredData?.length === studentLength ? studentLength :
				(tableDataSources[0]?.filteredData?.length + '/' + studentLength)}} Child(ren)
				<button class="pull-right" mat-raised-button color="primary" (click)="shoppingCartAddAll()"
					mat-button>Select All Children</button>
			</h2>
			<hr />

			<div class="row gx-0">
				<mat-form-field class="col-lg-12">
					<mat-label>
						Filter
					</mat-label>
					<input matInput id="filter" name="filter" type="string" [(ngModel)]="filter"
						(ngModelChangeDebounced)="setFilter();" />
				</mat-form-field>
			</div>

			<div class="table-responsive">
				<mat-table [dataSource]="tableDataSources[0]" class="mat-elevation-z1" matSort
					(matSortChange)="announceSortChange($event)">

					<ng-container matColumnDef="EDIT">
						<mat-header-cell *matHeaderCellDef> </mat-header-cell>
						<mat-cell *matCellDef="let element">
							<div>
								<button mat-icon-button color="primary" (click)="shoppingCartAdd(element)">
									<mat-icon [matTooltip]="'Add Child'" [matTooltipPosition]="'above'">add</mat-icon>
								</button>
								<edit-child-modal-btn [searchStudent]="element" [studentId]="element.ID" [type]="'icon'"
									[icon]="'visibility'">
								</edit-child-modal-btn>
							</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL.NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.SCHOOL.NAME}} </mat-cell>
					</ng-container>

					<ng-container matColumnDef="MSD_NUMBER">
						<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
						<mat-cell *matCellDef="let element">
							{{element.MSD_NUMBER}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SSID">
						<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.SSID}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="PERSON.LAST_NAME">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
							titlecase}}{{(element.SECOND_LAST_NAME
							? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}} {{element.PERSON.FIRST_NAME |
							titlecase}}
							{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="DOB">
						<mat-header-cell *matHeaderCellDef mat-sort-header> DOB </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.DOB | simpleDate}} ({{element.AGE}})</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SEX">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Gender </mat-header-cell>
						<mat-cell *matCellDef="let element"> {{element.SEX}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].GRADE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
						<mat-cell *matCellDef="let element" class="row">
							<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.GRADE}}</div>
						</mat-cell>
					</ng-container>

					<ng-container
						matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.QUALIFYING_ARRIVAL_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> QAD </mat-header-cell>
						<mat-cell *matCellDef="let element" class="row">
							<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
								{{sed.STUDENT_ELIGIBILITIES[0].CO.QUALIFYING_ARRIVAL_DATE | simpleDate}}</div>
						</mat-cell>
					</ng-container>

					<ng-container
						matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> EoE </mat-header-cell>
						<mat-cell *matCellDef="let element" class="row">
							<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
								{{sed.STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE | simpleDate}}</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Date </mat-header-cell>
						<mat-cell *matCellDef="let element" class="row">
							<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ENROLLMENT_DATE |
								simpleDate}}</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Withdrawal Date </mat-header-cell>
						<mat-cell *matCellDef="let element" class="row">
							<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.WITHDRAWAL_DATE |
								simpleDate}}</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].DEPARTURE_DATE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Departure Date </mat-header-cell>
						<mat-cell *matCellDef="let element" class="row">
							<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.DEPARTURE_DATE |
								simpleDate}}</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].TRACK">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Track </mat-header-cell>
						<mat-cell *matCellDef="let element" class="row">
							<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.TRACK}}</div>
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE">
						<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Type </mat-header-cell>
						<mat-cell *matCellDef="let element" class="row">
							<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ENROLLMENT_TYPE}}</div>
						</mat-cell>
					</ng-container>


					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns;"
						[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
						[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
						[matTooltipPosition]="'above'"
						[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
						[matTooltipClass]="'terminatedTooltip'"></mat-row>
				</mat-table>
			</div>
			<mat-paginator #paginators
				[pageSizeOptions]="[5, 10, 20, (tableDataSources ? tableDataSources[0] ? tableDataSources[0].data.length > 100 ? tableDataSources[0].data.length : 100 : 100 : 100)]"
				showFirstLastButtons aria-label="Select page of periodic elements"
				[hidden]="tableDataSources[0]?.filteredData?.length === 0">
			</mat-paginator>
		</div>


	</mat-tab>
	<mat-tab label="Individual Children Search">
		<app-search-children #tab2Search (shoppingCartChange)="searchChildrenShoppingCartEvent($event)"
			[shoppingCartInput]="searchChildrenShoppingCartInput" [hideShoppingCart]="true">
		</app-search-children>
	</mat-tab>
</mat-tab-group>
<div [hidden]="shoppingCartTableDataSources[0] ? shoppingCartTableDataSources[0].data?.length === 0 : true"
	class="margin-top-md">
	<h2>
		Chosen Children - {{shoppingCartTableDataSources[0]?.filteredData?.length === shoppingCartLength ?
		shoppingCartLength :
		(shoppingCartTableDataSources[0]?.filteredData?.length + '/' + shoppingCartLength)}} Child(ren)
		<button class="pull-right" mat-raised-button color="warn" (click)="shoppingCartRemoveAll()" mat-button>Clear
			Chosen Children</button>
	</h2>
	<hr />

	<div class="row gx-0">
		<mat-form-field class="col-lg-12">
			<mat-label>
				Filter
			</mat-label>
			<input matInput id="filter" name="filter" type="string" [(ngModel)]="shoppingCartFilter"
				(ngModelChangeDebounced)="setShoppingCartFilter();" />
		</mat-form-field>
	</div>

	<div class="table-responsive">
		<mat-table [dataSource]="shoppingCartTableDataSources[0]" class="mat-elevation-z1" matSort
			(matSortChange)="announceSortChange($event)">

			<ng-container matColumnDef="EDIT">
				<mat-header-cell *matHeaderCellDef> </mat-header-cell>
				<mat-cell *matCellDef="let element">
					<div>
						<button mat-icon-button color="primary" (click)="shoppingCartRemove(element)">
							<mat-icon [matTooltip]="'Remove Child'" [matTooltipPosition]="'above'">remove</mat-icon>
						</button>
						<edit-child-modal-btn [searchStudent]="element" [studentId]="element.ID" [type]="'icon'"
							[icon]="'visibility'">
						</edit-child-modal-btn>
					</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL.NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> School </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.SCHOOL?.NAME}} </mat-cell>
			</ng-container>

			<ng-container matColumnDef="MSD_NUMBER">
				<mat-header-cell *matHeaderCellDef mat-sort-header> MSD Number </mat-header-cell>
				<mat-cell *matCellDef="let element">
					{{element.MSD_NUMBER}}
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SSID">
				<mat-header-cell *matHeaderCellDef mat-sort-header> SSID </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.SSID}}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="PERSON.LAST_NAME">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Name </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.PERSON.LAST_NAME |
					titlecase}}{{(element.SECOND_LAST_NAME
					? ' ' + element.SECOND_LAST_NAME + ',': ',') | titlecase}} {{element.PERSON.FIRST_NAME |
					titlecase}}
					{{element.PERSON.MIDDLE_INITIAL | titlecase}}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="DOB">
				<mat-header-cell *matHeaderCellDef mat-sort-header> DOB </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.DOB | simpleDate}} ({{element.AGE}})</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SEX">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Gender </mat-header-cell>
				<mat-cell *matCellDef="let element"> {{element.SEX}}</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].GRADE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Grade </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.GRADE}}</div>
				</mat-cell>
			</ng-container>

			<ng-container
				matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].CO.QUALIFYING_ARRIVAL_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> QAD </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
						{{sed.STUDENT_ELIGIBILITIES[0].CO.QUALIFYING_ARRIVAL_DATE | simpleDate}}</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> EoE </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">
						{{sed.STUDENT_ELIGIBILITIES[0].ELIGIBILITY_END_DATE | simpleDate}}</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Date </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ENROLLMENT_DATE |
						simpleDate}}</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].WITHDRAWAL_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Withdrawal Date </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.WITHDRAWAL_DATE |
						simpleDate}}</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].DEPARTURE_DATE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Departure Date </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.DEPARTURE_DATE |
						simpleDate}}</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].TRACK">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Track </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.TRACK}}</div>
				</mat-cell>
			</ng-container>

			<ng-container matColumnDef="SCHOOL_ENROLLMENT_DETAILS[0].ENROLLMENT_TYPE">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Enroll Type </mat-header-cell>
				<mat-cell *matCellDef="let element" class="row">
					<div *ngFor="let sed of element.SCHOOL_ENROLLMENT_DETAILS">{{sed.ENROLLMENT_TYPE}}</div>
				</mat-cell>
			</ng-container>


			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: displayedColumns;"
				[ngClass]="{'terminatedRow': row.STUDENT_TERMINATION_STATUSES?.length > 0 && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID !== 1}"
				[matTooltip]="row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES.TYPE"
				[matTooltipPosition]="'above'"
				[matTooltipDisabled]="row.STUDENT_TERMINATION_STATUSES?.length === 0 || (row.STUDENT_TERMINATION_STATUSES && row.STUDENT_TERMINATION_STATUSES[0].STUDENT_TERMINATION_STATUS_TYPES_ID === 1)"
				[matTooltipClass]="'terminatedTooltip'"></mat-row>
		</mat-table>
	</div>
	<mat-paginator #paginators
		[pageSizeOptions]="[5, 10, 20, (shoppingCartTableDataSources ? shoppingCartTableDataSources[0] ? shoppingCartTableDataSources[0].data.length > 100 ? shoppingCartTableDataSources[0].data.length : 100 : 100 : 100)]"
		showFirstLastButtons aria-label="Select page of periodic elements"
		[hidden]="shoppingCartTableDataSources[0]?.filteredData?.length === 0">
	</mat-paginator>
</div>

<h2 *ngIf="shoppingCartLength === 0 && results.length > 0" class="text-center">
	<hr />
	Please select one or more children to continue...
</h2>

<div *ngIf="shoppingCartLength > 0">

	<div class="row">

		<div class="col-lg-6">

			<div class="row">
				<div class="col margin-sm text-center">
					<button type="button" color="primary" mat-raised-button
						(click)="addDialog(shoppingCartTableDataSources[0].data)"
						*ngIf="featurePermissions['Create Student School Enrollments']">
						Add new school enrollment{{shoppingCartLength > 1 ? 's': ''}} for {{shoppingCartLength > 1 ?
						shoppingCartLength + ' children': '1
						child'}}
					</button>
				</div>
			</div>

			<div class="row">
				<div class="col margin-sm text-center">
					<button type="button" color="accent" mat-raised-button
						(click)="promoteDialog(shoppingCartTableDataSources[0].data)"
						*ngIf="featurePermissions['Promote Group School Enrollments']"
						[disabled]="searchChildrenShoppingCart.length > 0">
						Promote {{shoppingCartLength > 1 ? shoppingCartLength + ' children': '1 child'}}
					</button>
				</div>
			</div>

			<div class="row">
				<div class="col margin-sm text-center">
					<button type="button" color="accent" mat-raised-button
						(click)="graduateDialog(shoppingCartTableDataSources[0].data)"
						*ngIf="featurePermissions['Graduate Group School Enrollments']"
						[disabled]="searchChildrenShoppingCart.length > 0">
						Graduate {{shoppingCartLength > 1 ? shoppingCartLength + ' children': '1 child'}}
					</button>
				</div>
			</div>
		</div>

		<div class="col-lg-6">
			<div class="row">
				<div class="col margin-sm text-center">
					<button type="button" color="primary" mat-raised-button
						(click)="editDialog(shoppingCartTableDataSources[0].data)"
						*ngIf="featurePermissions['Edit Student School Enrollments']"
						[disabled]="searchChildrenShoppingCart.length > 0">
						Update school enrollment{{shoppingCartLength > 1 ? 's': ''}} for {{shoppingCartLength > 1 ?
						shoppingCartLength + ' children': '1 child'}}
					</button>
				</div>
			</div>
			<div class="row">
				<div class="col margin-sm text-center">
					<button type="button" color="warn" mat-raised-button
						(click)="deleteDialog(shoppingCartTableDataSources[0].data)"
						*ngIf="featurePermissions['Delete Student School Enrollments']"
						[disabled]="searchChildrenShoppingCart.length > 0">
						Delete school enrollment{{shoppingCartLength > 1 ? 's': ''}} for {{shoppingCartLength > 1 ?
						shoppingCartLength + ' children': '1 child'}}
					</button>
				</div>
			</div>
		</div>
	</div>
</div>